import React, { useState, useEffect, useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import AgGridComponent from "../../../AG-grid/AgGridComponent";
import { Row, Col, Input, Button, Tooltip } from "antd";
import {
  IconKerko,
  DeleteIcon,
  // IconFilter,
  IconNdrysho,
  IconExcel,
  IconNgargo,
} from "../../../../assets/icons";
import { API } from "aws-amplify";
import "./menyrat_pageses.scss";
import MenyratPgaesesModal from "./MenyratPgaesesModal";
import GlobalPopupKonfirm from "../../../commonComponents/GlobalPopupKonfirm";
import MenyratFilterModal from "./MenyratFilterModal";
import LoadableComp from "../../../commonComponents/LoadableComp/LoadableComp";
import { htmlParser } from "../../../../utils";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import { useReactToPrint } from "react-to-print";
import HtmlExelTabel from "../../dynamic components/HtmlExelTabel";
import ExportToPdf from "../../dynamic components/ExportToPdf";
import { getSocketUrl } from "../../../../utils/websocketConfig";
import { useDispatch } from "react-redux";
import { requestData } from "../../../../helpers/API/RequestFactory";
import { useMediaQuery } from "react-responsive";
import MobileMenyratPageses from "./MobileMenyratPageses";
import PaisjetOraritLogs from "../../SistemiSettings/SistemiPaisjetOrarit/PaisjetOraritLogs";
import { LogsIcon } from "../../../Documentation/View/assets";
import AgGridHeader from "../../../commonComponents/AgGridHeader/AgGridHeader";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";

/**
 * * @EneaXharau - Websocket connection
 */
// const socketHandler = new WebSocket(
//   getSocketUrl("/settings/wages/payment/sockets")
// );

const FILTER_KEYS = [
  { key: "name", label: "Mënyrat e pagesës", type: "string" },
  {
    key: "description",
    label: "Përshkrimi i mënyrës",
    type: "string",
  },
  { key: "formula", label: "Formula për llogaritjen", type: "string" },
];
const EXPORT_COLS = [
  { en: "name", al: "Mënyrat e pagesës" },
  { en: "description", al: "Përshkrimi i mënyrës" },
  { en: "formula", al: "Formula për llogaritjen" },
];

function MenyratPageses() {
  // column defs that are show in AgGrid
  const columnDefs = [
    {
      headerName: "Nr.",
      field: "id",
      // checkboxSelection: true,
      // headerCheckboxSelection: true,
      flex: 1,
      hide: true,
    },
    {
      headerName: "Mënyrat e pagesës",
      field: "name",
      mobile: true,
      isCollapseTitle: true,
      filter: "agTextColumnFilter",
      flex: 3,
    },
    {
      headerName: "Përshkrimi i mënyrës",
      field: "description",
      filter: "agTextColumnFilter",
      mobile: true,
      flex: 5,
      cellRenderer: ({ data }) => htmlParser(data?.description),
    },
    {
      headerName: "Formula për llogaritjen",
      field: "formula",
      mobile: true,
      filter: "agTextColumnFilter",
      flex: 5,
    },
    {
      headerName: "",
      field: "",
      filter: "agTextColumnFilter",
      flex: 2,
      cellRenderer: (params) => (
        <div className="iconat-paisjet">
          <div variant="outlined" cursor="pointer" className="icon-edit">
            <IconNdrysho
              onClick={() => handleUpdate(params.data)}
              width={14}
              height={14}
            />
          </div>
          <GlobalPopupKonfirm
            Button={
              <div variant="outlined" cursor="pointer" className="icon-delete">
                <DeleteIcon
                  width={17}
                  height={17}
                  // onClick={() => handleRequestDelete(params.node.data.id)}
                />
              </div>
            }
            title={"Jeni të sigurt që do të fshini këtë rekord?"}
            onConfirm={() => handleRequestDelete(params.node.data.id)}
            okText={"Po"}
            cancelText={"Jo"}
          />
        </div>
      ),
    },
  ];

  const initialValue = {
    name: "",
    description: "",
    formula: "",
  };

  const [gridApi, setGridApi] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [visible, setVisible] = useState(false);
  const { programFields } = useSelector((state) => state.programFields);
  const [request, setRequests] = useState([]);
  const [dataLista, setDataLista] = useState(initialValue);
  const [shouldShowError, setShouldShowError] = useState(false);
  const [agGridSearchInput, setAgGridSearchInput] = useState(null);
  const [logsVisible, setLogsVisible] = useState(false);
  const dispatch = useDispatch();

  // * @EneaXharau - Put filterData in useMemo in order to prevent re-rendering
  const filterData = useMemo(() => {
    return programFields?.find(
      (data) => data?.fieldId === "01d6ec94-5ddf-4f48-9fdc-86a39a7289d9"
    );
  }, [programFields]);

  // open the modal to create a new record
  const handleCLickOpen = () => {
    setVisible(true);
    setDataLista(initialValue);
    setShouldShowError(true);
  };

  /**
   * * @EneaXharau - Async function taking no parameters
   * * it awaits for redux to fetch data from AWS database
   * * then sets in state which also re-renders component to display new info
   */
  const refreshRedux = async () => {
    requestData("programFields").then((res) => dispatch(programFields(res)));
  };

  // get the data and save it in state
  const fetchData = () => {
    const fieldsData = filterData;
    setTableData(fieldsData?.fieldOptions);
    setRequests(fieldsData);
  };

  // delete the selected data
  const handleRequestDelete = (id) => {
    let newArray = tableData.filter((r) => r.id !== id);
    API.put(
      "programFields",
      "/programFields/01d6ec94-5ddf-4f48-9fdc-86a39a7289d9",
      {
        body: {
          fieldOptions: newArray,
        },
      }
    ).then(() => {
      /**
       * * @EneaXharau - Added socket emitter
       * * .send() takes -> { request: String, body: any} -> stringified
       */
      // if (socketHandler.readyState === socketHandler.OPEN)
      //   socketHandler.send(
      //     JSON.stringify({
      //       request: "wage_removed",
      //       body: "A wage was removed",
      //     })
      //   );
      setTableData(newArray);
      let field = request.fieldOptions.filter((el) => el.id !== id);
      setRequests((prev) => ({ ...prev, fieldOptions: field }));
    });
  };

  // open the update modal
  const handleUpdate = (oldData) => {
    setVisible(true);
    setDataLista(oldData);
    setShouldShowError(false);
  };

  // make the agGrid ready
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  // clear the advanced filters
  const clearFilters = () => {
    gridApi.setFilterModel(null);
    gridApi.onFilterChanged(null);
    gridApi.setGridOption("quickFilterText", null);
    setAgGridSearchInput(null);
  };

  // global search for ag grid
  const onFilterTextChange = (e) => {
    gridApi.setGridOption("quickFilterText", e.target.value);
    setAgGridSearchInput(e.target.value);
  };

  // dropdon filter check to not repeat same value 2 times
  const duplicateCheck = [];
  const descriptionduplicateCheck = [];
  const formuladuplicateCheck = [];

  tableData &&
    tableData
      ?.map((data) => {
        if (duplicateCheck.includes(data.name)) return null;
        duplicateCheck.push(data.name);
        return data;
      })
      .filter((e) => e);

  tableData &&
    tableData
      ?.map((data) => {
        if (descriptionduplicateCheck.includes(data.description)) return null;
        descriptionduplicateCheck.push(data.description);
        return data;
      })
      .filter((e) => e);

  tableData &&
    tableData
      ?.map((data) => {
        if (formuladuplicateCheck.includes(data.formula)) return null;
        formuladuplicateCheck.push(data.formula);
        return data;
      })
      .filter((e) => e);

  const componentRef = useRef("Print-Punojsit");
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  let rowData = [];
  gridApi?.forEachNodeAfterFilter?.((node) => {
    rowData?.push(node?.data);
  });

  /**
   * * @EneaXharau - useEffect to listen to socket emits from backend
   * * and run a function with a setTimeout to cancel the delay of emitting
   * * according to its emit request.
   * * .onmessage is a variable that needs to be a function (arrow preferably)
   * * .onmessage takes a parameter from backend which is is a stringified object
   */
  // useEffect(() => {
  // 	socketHandler.onmessage = (msg) => {
  // 		const { request, body } = JSON.parse(msg.data);
  // 		switch (request) {
  // 			case "wage_added_received": {
  // 				refreshRedux();
  // 				break;
  // 			}
  // 			case "wage_removed_received": {
  // 				refreshRedux();
  // 				break;
  // 			}
  // 			case "wage_updated_received": {
  // 				refreshRedux();
  // 				break;
  // 			}
  // 			default:
  // 				break;
  // 		}
  // 	};
  // 	return () => socketHandler.close();
  // }, []);

  const isMobileView = useMediaQuery({
    query: "(min-width: 460px)",
  });

  // get data when page is rendered
  useEffect(() => {
    fetchData();
  }, [filterData]);

  const ITEMS = {
    search: {},
    icons: {
      filter: {
        filterKeys: FILTER_KEYS,
      },
      excel: { tableCols: EXPORT_COLS },
      pdf: { tableCols: EXPORT_COLS },
      print: { tableCols: EXPORT_COLS },
      modals: [{ onClick: () => setLogsVisible(true) }],
    },
  };

  //region RETURN
  return (
    <LoadableComp loading={!!tableData ? false : true}>
      <div className="globalPageWrapper">
        <AgGridComponent
          gridApi={gridApi}
          rowData={tableData}
          rowSelection={{ mode: "singleRow" }}
          onGridReady={onGridReady}
          paginationPageSize={15}
          columnDefs={columnDefs}
          headerProps={{
            items: ITEMS,
            exportTitle: "Menyrat e pageses",
            children: [
              <MondayButton
                className="mondayButtonGreen"
                onClick={handleCLickOpen}
              >
                Shto një mënyrë pagese
              </MondayButton>,
            ],
          }}
          idKey={"id"}
        />
      </div>
      {visible ? (
        <MenyratPgaesesModal
          {...{
            visible,
            setVisible,
            request,
            setTableData,
            setRequests,
            tableData,
            dataLista,
            setShouldShowError,
            shouldShowError,
            // socketHandler,
            socketHandler: () => {},
          }}
        />
      ) : null}
      {logsVisible ? (
        <PaisjetOraritLogs
          isVisible={logsVisible}
          setIsVisible={setLogsVisible}
          data={tableData}
          logsName={"Mënyrat e Pagesës"}
        />
      ) : null}
    </LoadableComp>
  );
}

export default MenyratPageses;
